import React, { useState, useEffect } from 'react';
import './QuienesSomosPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const QuienesSomosPage = () => {
  const [activeTimeline, setActiveTimeline] = useState(0);

  // Scroll al top cuando se monta el componente
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const team = [
    {
      name: 'Javier Gómez',
      role: 'Fundador y CEO',
      image: '/images/javi-team.jpg',
      description: 'Hola, soy Javi y este es mi ecosistema que llamo Javiland. En Javiland encontrarás productos y servicios que he aprendido en mi camino y los pongo al servicio por este medio electrónico.',
      specialties: ['Mis 5 Pilares de Vida', 'Filosofía Anárquica', 'Servicio Genuino'],
      personalContent: {
        pillars: [
          { icon: '🧠', name: 'Conocimiento' },
          { icon: '🏛️', name: 'Babilonia' },
          { icon: '☮️', name: 'Paz y Armonía' },
          { icon: '💝', name: 'Emociones' },
          { icon: '💪', name: 'Cuerpo' }
        ],
        philosophy: {
          approach: 'Creo mi propio camino donde la autenticidad y el servicio genuino son la base de todo lo que hago.',
          commitment: 'Comparto contigo lo que he aprendido en mi camino, desde mi experiencia personal y mi forma genuina de servir.'
        }
      }
    },
    {
      name: 'María González',
      role: 'Directora de Bienestar',
      image: '/images/maria-team.jpg',
      description: 'Especialista en bienestar integral y desarrollo personal con certificaciones internacionales',
      specialties: ['Yoga', 'Meditación', 'Coaching Personal']
    },
    {
      name: 'Carlos Ruiz',
      role: 'Director de Tecnología',
      image: '/images/carlos-team.jpg',
      description: 'Experto en desarrollo de software y arquitectura de sistemas con más de 8 años de experiencia',
      specialties: ['Desarrollo Web', 'Inteligencia Artificial', 'Cloud Computing']
    },
    {
      name: 'Ana Martínez',
      role: 'Directora de Estrategia',
      image: '/images/ana-team.jpg',
      description: 'Consultora estratégica especializada en transformación digital y gestión de proyectos',
      specialties: ['Consultoría', 'Gestión de Proyectos', 'Transformación Digital']
    }
  ];

  const timeline = [
    {
      year: '2019',
      title: 'Fundación de Javiland',
      description: 'Inicio del ecosistema con la visión de combinar tecnología, bienestar y creatividad',
      milestone: 'Primera oficina en Bogotá'
    },
    {
      year: '2020',
      title: 'Lanzamiento de Product Studio',
      description: 'Inicio de servicios de desarrollo de software y consultoría tecnológica',
      milestone: 'Primeros 10 clientes'
    },
    {
      year: '2021',
      title: 'Expansión Musical',
      description: 'Nacimiento de Javi Roots como proyecto musical y cultural',
      milestone: 'Primer álbum lanzado'
    },
    {
      year: '2022',
      title: 'Crecimiento del Ecosistema',
      description: 'Apertura de nuevos servicios y consolidación del equipo',
      milestone: '50+ proyectos completados'
    },
    {
      year: '2023',
      title: 'Innovación en Bienestar',
      description: 'Desarrollo de plataformas digitales para bienestar y desarrollo personal',
      milestone: '1000+ usuarios activos'
    },
    {
      year: '2024',
      title: 'Expansión Internacional',
      description: 'Apertura de servicios en mercados internacionales y nuevas alianzas',
      milestone: 'Presencia en 3 países'
    }
  ];

  const values = [
    {
      icon: 'fas fa-heart',
      title: 'Pasión',
      description: 'Nos apasiona crear soluciones que impacten positivamente la vida de las personas'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'Innovación',
      description: 'Buscamos constantemente nuevas formas de resolver problemas y crear valor'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Integridad',
      description: 'Actuamos con honestidad, transparencia y respeto en todas nuestras relaciones'
    },
    {
      icon: 'fas fa-users',
      title: 'Colaboración',
      description: 'Creemos en el poder del trabajo en equipo y la diversidad de perspectivas'
    },
    {
      icon: 'fas fa-leaf',
      title: 'Sostenibilidad',
      description: 'Nos comprometemos con prácticas responsables y el cuidado del medio ambiente'
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Aprendizaje',
      description: 'Fomentamos el crecimiento continuo y el desarrollo personal y profesional'
    }
  ];

  const achievements = [
    { number: '150+', label: 'Proyectos Completados' },
    { number: '50+', label: 'Clientes Satisfechos' },
    { number: '5', label: 'Años de Experiencia' },
    { number: '25+', label: 'Miembros del Equipo' }
  ];

  return (
    <div className="quienes-somos-page">
      <Header />
      <AnimatedBackground particleCount={20} staticCount={6} />
      
      <main className="quienes-main">
        <div className="container">
          {/* Hero Section */}
          <section className="hero-section">
            <div className="hero-content">
              <h1 className="hero-title">Quiénes Somos</h1>
              <p className="hero-subtitle">
                Un ecosistema innovador que combina tecnología, bienestar y creatividad para impulsar 
                el crecimiento personal y profesional de manera holística
              </p>
            </div>
          </section>

          {/* Mission Section */}
          <section className="mission-section">
            <div className="mission-content">
              <div className="mission-text">
                <h2>Nuestra Misión</h2>
                <p>
                  Crear un ecosistema integral que conecte tecnología, bienestar y creatividad para 
                  empoderar a las personas y organizaciones en su camino hacia el crecimiento sostenible 
                  y el bienestar integral.
                </p>
                <h3>Nuestra Visión</h3>
                <p>
                  Ser el referente líder en Latinoamérica en la creación de ecosistemas que transformen 
                  la manera en que las personas y organizaciones abordan su desarrollo personal y profesional.
                </p>
              </div>
              <div className="mission-image">
                <img src="/images/mision-vision.jpg" alt="Misión y Visión" />
              </div>
            </div>
          </section>

          {/* Values Section */}
          <section className="values-section">
            <h2 className="section-title">Nuestros Valores</h2>
            <div className="values-grid">
              {values.map((value, index) => (
                <div key={index} className="value-card">
                  <div className="value-icon">
                    <i className={value.icon}></i>
                  </div>
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Team Section */}
          <section className="team-section">
            <h2 className="section-title">Nuestro Equipo</h2>
            <div className="team-grid">
              {team.map((member, index) => (
                <div key={index} className="team-card">
                  <div className="member-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="member-info">
                    <h3 className="member-name">{member.name}</h3>
                    <p className="member-role">{member.role}</p>
                    <p className="member-description">{member.description}</p>
                    <div className="member-specialties">
                      {member.specialties.map((specialty, idx) => (
                        <span key={idx} className="specialty-tag">{specialty}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Javi's Personal Section */}
          <section className="javi-personal-section">
            <div className="javi-content">
              <div className="javi-intro">
                <h2>Conoce a Javi</h2>
                <p className="javi-description">
                  Hola, soy Javi y este es mi ecosistema que llamo Javiland. 
                  En Javiland encontrarás productos y servicios que he aprendido en mi camino y los pongo al servicio por este medio electrónico.
                </p>
              </div>
              
              <div className="javi-pillars">
                <h3>Mis 5 Pilares de Vida</h3>
                <div className="pillars-grid">
                  {team[0].personalContent.pillars.map((pillar, index) => (
                    <div key={index} className="pillar-item">
                      <div className="pillar-icon">{pillar.icon}</div>
                      <div className="pillar-name">{pillar.name}</div>
                    </div>
                  ))}
                </div>
                <p className="pillars-description">
                  Estos pilares guían mi forma de vivir y compartir. Javiland es mi forma de expresarlos.
                </p>
              </div>

              <div className="javi-philosophy">
                <div className="philosophy-card">
                  <h3>Mi Enfoque</h3>
                  <p>{team[0].personalContent.philosophy.approach}</p>
                </div>
                <div className="philosophy-card">
                  <h3>Mi Compromiso Contigo</h3>
                  <p>{team[0].personalContent.philosophy.commitment}</p>
                </div>
              </div>
            </div>
          </section>

          {/* Timeline Section */}
          <section className="timeline-section">
            <h2 className="section-title">Nuestra Historia</h2>
            <div className="timeline-container">
              <div className="timeline-nav">
                {timeline.map((item, index) => (
                  <button
                    key={index}
                    className={`timeline-nav-btn ${activeTimeline === index ? 'active' : ''}`}
                    onClick={() => setActiveTimeline(index)}
                  >
                    {item.year}
                  </button>
                ))}
              </div>
              <div className="timeline-content">
                <div className="timeline-item">
                  <h3 className="timeline-title">{timeline[activeTimeline].title}</h3>
                  <p className="timeline-description">{timeline[activeTimeline].description}</p>
                  <div className="timeline-milestone">
                    <i className="fas fa-star"></i>
                        <span>{timeline[activeTimeline].milestone}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Achievements Section */}
          <section className="achievements-section">
            <h2 className="section-title">Nuestros Logros</h2>
            <div className="achievements-grid">
              {achievements.map((achievement, index) => (
                <div key={index} className="achievement-card">
                  <div className="achievement-number">{achievement.number}</div>
                  <div className="achievement-label">{achievement.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Culture Section */}
          <section className="culture-section">
            <div className="culture-content">
              <div className="culture-text">
                <h2>Nuestra Cultura</h2>
                <p>
                  En Javiland creemos que el éxito viene de la combinación perfecta entre innovación 
                  tecnológica, bienestar personal y creatividad. Nuestra cultura se basa en:
                </p>
                <ul className="culture-list">
                  <li>
                    <i className="fas fa-check"></i>
                    <span>Flexibilidad y equilibrio trabajo-vida</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>
                    <span>Desarrollo continuo y aprendizaje</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>
                    <span>Colaboración y trabajo en equipo</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>
                    <span>Innovación y pensamiento disruptivo</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>
                    <span>Impacto positivo en la comunidad</span>
                  </li>
                </ul>
              </div>
              <div className="culture-image">
                <img src="/images/cultura-equipo.jpg" alt="Cultura de Equipo" />
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section className="contact-section">
            <div className="contact-content">
              <h2>¿Quieres Conocernos Mejor?</h2>
              <p>
                Estamos siempre abiertos a nuevas conversaciones, colaboraciones y oportunidades 
                de crecimiento conjunto.
              </p>
              <div className="contact-actions">
                <button className="primary-btn">
                  <i className="fas fa-envelope"></i>
                  Contáctanos
                </button>
                <button className="secondary-btn">
                  <i className="fas fa-calendar"></i>
                  Agenda una Reunión
                </button>
              </div>
            </div>
          </section>
        </div>
      </main>

    </div>
  );
};

export default QuienesSomosPage;
